import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"


const __default__ = {
  name: 'FabricGroup',
};

import {
  getCurrentInstance,
  inject,
  onMounted,
  PropType,
  provide,
  ref,
  Slot,
  watch,
} from 'vue';
import {
  commonProps,
  FabricExposition,
  GroupExposition,
  injectionKey,
} from '@/core/components/data-display/Fabric/fabric.shared';
import { fabric } from 'fabric';
import { useFabricObject } from '@/core/components/data-display/Fabric/fabric.hooks';
import { Deferred } from '@/utils/promise';
import { renderObject } from '@/core/components/data-display/Fabric/fabric';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  ...commonProps,
  options: {
    type: Object as PropType<fabric.IGroupOptions>,
    default: () => ({}),
  },
},
  setup(__props, { expose }) {

const props = __props


const fabricInjection = inject<FabricExposition>(injectionKey);
const deferredObject = Deferred<fabric.Group>();
const vm: ReturnType<typeof getCurrentInstance> = getCurrentInstance();
const objects = ref<Promise<fabric.Object>[]>([]);

let group: fabric.Group | undefined;
useFabricObject(() => group, props);
const isCreatingObject = ref(false);
const createObject = (): Promise<fabric.Group> => new Promise((resolve) => {
  setTimeout(resolve, 500);
})
  .then(() => Promise.all(objects.value))
  .then((resolvedObjects) => {
    group = new fabric.Group(resolvedObjects.filter(Boolean), props.options);
    group.set('strokeWidth', 0);
    deferredObject.resolve(group);
    return group;
  });

onMounted(() => {
  /**
   * NOTE: We need to get all child objects inside the group before adding the group to the canvas
   * due to some bug in fabric. Adding objects after the group has been added to the canvas will reset
   * the group position and we can't reset it afterwards for some reason
   * * */
  const canvas = fabricInjection?.getCanvas();
  deferredObject.promise.then((object) => {
    renderObject({
      object,
      canvas,
      deferredObject,
      vm,
    });
  });
});

watch(() => [objects], () => {
  if (!isCreatingObject.value) {
    isCreatingObject.value = true;
    createObject();
  }
}, { deep: true });

expose<GroupExposition>({
  objects,
  deferredObject,
});

provide<GroupExposition>('group', {
  objects,
  deferredObject,
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})